import Budget from "models/Budget";
import { GenericService, Service } from "./genericService";

class BudgetService extends GenericService<Budget> implements Service<Budget> {
  constructor() {
    super("api/Budget");
  }
}

export default new BudgetService();
